import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

// Hook customizado simples para "debounce" (atrasar a execução)
// (Sem alterações)
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

function ProjetoCompleto() {
  // ----- ESTADOS -----
  // (Sem alterações)
  const [projetos, setProjetos] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [userSecretariaId, setUserSecretariaId] = useState("");

  // Estado da busca
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  // Estados da Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationInfo, setPaginationInfo] = useState(null);

  const location = useLocation();

  // ----- EFEITO PARA BUSCAR DADOS (ATUALIZADO) -----
  useEffect(() => {
    // Carrega permissões
    const role = localStorage.getItem("UserRole") || "";
    const secretariaId = localStorage.getItem("UserSecretariaId") || "";
    setUserRole(role);
    setUserSecretariaId(secretariaId);

    // Pega os parâmetros da URL
    const params = new URLSearchParams(location.search);
    const idSecretaria = params.get("id_secretaria");
    
    // --- CORREÇÃO 1: Ler o parâmetro 'status' da URL ---
    const status = params.get("status");

    // Monta a URL da API com paginação e busca
    let url = `/api/projetocompleto?page=${currentPage}&limit=10`;

    // Filtro de Secretaria (sem alteração)
    if (idSecretaria) {
      url += `&id_secretaria=${idSecretaria}`;
    }
    
    // Filtro de Busca (sem alteração)
    if (debouncedSearchTerm) {
      url += `&search=${debouncedSearchTerm}`;
    }

    // --- CORREÇÃO 2: Adicionar o 'status' na URL da API ---
    if (status) {
      url += `&status=${status}`;
    }

    // Chamada da API (sem alteração)
    axios
      .get(url)
      .then((res) => {
        if (res.data.Status === "Success") {
          // Atualiza os projetos E as informações de paginação
          setProjetos(res.data.Result);
          setPaginationInfo(res.data.Pagination);
        } else {
          alert("Erro ao buscar dados");
        }
      })
      .catch((err) => {
        console.error("Erro na requisição:", err);
      });

    // Roda este efeito se a página, o filtro de secretaria ou a busca mudarem
  }, [location.search, currentPage, debouncedSearchTerm]);

  // ----- HANDLERS (Manipuladores) -----
  // (Sem alterações)

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Volta para a página 1 ao iniciar uma nova busca
  };

  // Funções para mudar de página
  const goToNextPage = () => {
    if (paginationInfo && currentPage < paginationInfo.totalPages) {
      setCurrentPage((page) => page + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((page) => page - 1);
    }
  };

  // Permissão (sem alteração)
  const podeEditar = (projetoSecretariaId) => {
    return (
      userRole === "admin" ||
      (projetoSecretariaId && projetoSecretariaId.toString() === userSecretariaId)
    );
  };

  // ----- RENDERIZAÇÃO -----
  return (
    <div className="px-5 py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3
          className="m-0"
          style={{
            fontSize: "1.75rem",
            fontWeight: "bold",
            color: "#2c3e50",
            borderBottom: "3px solid #3498db",
            paddingBottom: "10px",
            display: "inline-block",
          }}
        >
          Lista de Processos
        </h3>
        {(userRole === "admin" || userRole === "user") && (
          // --- CORREÇÃO DE ROTA ---
          <Link to="/createprojetocompleto" className="btn btn-success">
            Adicionar Projeto
          </Link>
        )}
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Pesquisar por nome do projeto ou secretaria..."
          value={searchTerm}
          onChange={handleSearch}
        />
      </div>

      <div className="table-responsive">
        <table className="table table-striped tabela-pequena">
          <thead>
            <tr>
              <th>Secretaria</th>
              <th>Nome do Processo</th>
              <th>Gestor</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {projetos.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center"> {/* Colspan ajustado para 4 */}
                  Nenhum projeto encontrado.
                </td>
              </tr>
            ) : (
              projetos.map((completo) => (
                <tr key={completo.id}>
                  <td>{completo.secretaria_nome}</td>
                  <td>{completo.nomeprojeto}</td>
                  {/* Corrigido para 'gestor' (baseado no seu 'addprojetocompleto.js') */}
                  <td>{completo.gestor}</td> 
                  <td style={{ width: "10px" }}>
                    {/* --- CORREÇÃO DE ROTA --- */}
                    <Link
                      to={`/viewprojetocompleto/${completo.id}`}
                      className="btn btn-secondary btn-sm me-2 w-100 mb-1 p-1 " // 'btn-secundary' corrigido para 'btn-secondary'
                    >
                      Visualizar
                    </Link>
                    {/* --- CORREÇÃO DE ROTA --- */}
                    <Link
                      to={`/gantt3/${completo.id}`}
                      className="btn btn-info btn-sm me-2 w-100 mb-2 p-1 "
                    >
                      Gantt
                    </Link>
                    {podeEditar(completo.id_secretaria) && (
                      // --- CORREÇÃO DE ROTA ---
                      <Link
                        to={`/editprojetocompleto/${completo.id}`}
                        className="btn btn-primary btn-sm me-2 w-100 p-1 buttom-0 end-0 "
                      >
                        Editar
                      </Link>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ----- CONTROLES DE PAGINAÇÃO ----- */}
      {paginationInfo && paginationInfo.totalPages > 1 && (
        <nav className="d-flex justify-content-between align-items-center">
          <div>
            <span className="text-muted small">
              Página {paginationInfo.page} de {paginationInfo.totalPages}
              (Total: {paginationInfo.totalItems} projetos)
            </span>
          </div>
          <div>
            <button
              className="btn btn-outline-primary me-2"
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              Anterior
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={goToNextPage}
              disabled={currentPage === paginationInfo.totalPages}
            >
              Próxima
            </button>
          </div>
        </nav>
      )}
    </div>
  );
}

export default ProjetoCompleto;